import { Col, Row, Popover, Input,Pagination } from 'antd';
import './index.css'
import {useNavigate} from "react-router-dom";
import {CheckSquareFilled, BorderOutlined, ClearOutlined} from '@ant-design/icons';
import iconCategorie from '@/assets/image/icon_categorie.png'
import iconShare from '@/assets/image/ecosystem/icon_share.png'
import iconNetwork from '@/assets/image/ecosystem/icon_network.png'
import iconSearch from '@/assets/image/icon_search.png'
import React, {useEffect, useState} from 'react';
import mockList from './data'
const mockCategorieList = [
    {
        id: 1,
        checked: false,
        name: 'Infra'
    }, {
        id: 2,
        checked: false,
        name: 'Payment'
    }, {
        id: 3,
        checked: false,
        name: 'Yield'
    }, {
        id: 4,
        checked: false,
        name: 'Stablecoin'
    }, {
        id: 5,
        checked: false,
        name: 'RWA'
    }, {
        id: 6,
        checked: false,
        name: 'Wallet'
    }, {
        id: 7,
        checked: false,
        name: 'RWA'
    }, {
        id: 8,
        checked: false,
        name: 'ZK'
    }, {
        id: 9,
        checked: false,
        name: 'CeDeFi'
    }, {
        id: 10,
        checked: false,
        name: 'DeFi'
    }, {
        id: 11,
        checked: false,
        name: 'AI Agent'
    }, {
        id: 12,
        checked: false,
        name: 'DevTool'
    }, {
        id: 13,
        checked: false,
        name: 'BTC'
    }]

const Ecosystem = (props) => {
    // 使用 useState 来存储输入框的值
    const navigate = useNavigate();
    const [filterCategories, setFilterCategories] = useState([]);
    const [inputValue, setInputValue] = useState('');
    const [list, setList] = useState([])
    const [total, setTotal] = useState(0); // 筛选后的总条数
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(12);
    const [categorieList, setCategorieList] = useState(mockCategorieList);

    const onPageChange = (page, size) => {
        setCurrentPage(page);
        setPageSize(size);
        const indexOfLastItem = page * size;
        const indexOfFirstItem = indexOfLastItem - size;
        const currentData = mockList.slice(indexOfFirstItem, indexOfLastItem);
        setList(currentData); // 这样 setList 拿到的就是正确的数据了
    };

    function handleCheckCategorie(item, index) {
        const list = [...categorieList]
        list[index].checked = !list[index].checked
        const filterCategories = list.filter(item => item.checked)
        const names = filterCategories.map(item => item.name);
        setFilterCategories(names)
        setCategorieList(JSON.parse(JSON.stringify(list)))
    }

    // useEffect(() => {
    //     if ( filterCategories.length || inputValue) {
    //         const valueLowerCase = inputValue.toLowerCase()
    //         // 使用 filter 和 some 方法筛选包含指定标签的对象
    //         let results = []
    //         if (filterCategories.length > 0) {
    //             results = mockList.filter(item =>
    //                 item.tagList.some(tag => filterCategories.includes(tag.name)) && ((item?.title?.toLowerCase())?.includes(valueLowerCase) || (item?.content?.toLowerCase())?.includes(valueLowerCase))
    //             )
    //         }
    //         if (filterCategories.length === 0) {
    //             results = mockList.filter(item => ((item.title?.toLowerCase()).includes(valueLowerCase) || (item.content?.toLowerCase()).includes(valueLowerCase)))
    //         }
    //         setList(JSON.parse(JSON.stringify(results)))
    //     } else {
    //         const indexOfLastItem = currentPage * pageSize;
    //         const indexOfFirstItem = indexOfLastItem - pageSize;
    //
    //         const currentData = mockList.slice(indexOfFirstItem, indexOfLastItem);
    //         setList(currentData)
    //     }
    // }, [filterCategories, inputValue]);

    // useEffect(() => {
    //     if ( filterCategories.length || inputValue) {
    //         const valueLowerCase = inputValue.toLowerCase()
    //         // 使用 filter 和 some 方法筛选包含指定标签的对象
    //         let results = []
    //         if (filterCategories.length > 0) {
    //             results = mockList.filter(item =>
    //               item.tagList.some(tag => filterCategories.includes(tag.name)) && ((item?.title?.toLowerCase())?.includes(valueLowerCase) || (item?.content?.toLowerCase())?.includes(valueLowerCase))
    //             )
    //         }
    //         if (filterCategories.length === 0) {
    //             results = mockList.filter(item => ((item.title?.toLowerCase()).includes(valueLowerCase) || (item.content?.toLowerCase()).includes(valueLowerCase)))
    //         }
    //         setList(JSON.parse(JSON.stringify(results)))
    //     } else {
    //         const indexOfLastItem = currentPage * pageSize;
    //         const indexOfFirstItem = indexOfLastItem - pageSize;
    //
    //         const currentData = mockList.slice(indexOfFirstItem, indexOfLastItem);
    //         setList(currentData)
    //     }
    // }, [filterCategories, inputValue]);

    // 监听 筛选条件 和 分页状态 的变化
    useEffect(() => {
        const valueLowerCase = inputValue.toLowerCase();

        // --- 第一步：全量筛选 ---
        const filteredResults = mockList.filter(item => {
            const matchesCategory = filterCategories.length === 0 ||
              item.tagList.some(tag => filterCategories.includes(tag.name));

            const matchesSearch = (item.title?.toLowerCase().includes(valueLowerCase)) ||
              (item.content?.toLowerCase().includes(valueLowerCase));

            return matchesCategory && matchesSearch;
        });

        // --- 第二步：更新总条数 (用于分页器显示) ---
        setTotal(filteredResults.length);

        // --- 第三步：物理截取当前页数据 ---
        const indexOfLastItem = currentPage * pageSize;
        const indexOfFirstItem = indexOfLastItem - pageSize;
        const currentData = filteredResults.slice(indexOfFirstItem, indexOfLastItem);

        // --- 第四步：设置渲染数据 ---
        setList(currentData);

    }, [filterCategories, inputValue, currentPage, pageSize]);

    useEffect(() => {
        setCurrentPage(1);
    }, [filterCategories, inputValue]);

    const handleClearCategorie = () => {
        setFilterCategories([])
        const list = [...categorieList]
        list.map(item => item.checked = false)
        setCategorieList(JSON.parse(JSON.stringify(list)))
    }

    const categorieContent = <div className="check-list">
        {
            filterCategories.length > 0 ? (
                <div className="check-clear" onClick={() => handleClearCategorie()}><ClearOutlined/> Clear Selection
                </div>
            ) : null
        }
        {
            categorieList.map(((item, index) =>
                    <div className="check-item flex" key={index} onClick={() => handleCheckCategorie(item, index)}>
                        {
                            item.checked ? <CheckSquareFilled/> : !item.checked ? <BorderOutlined/> : null
                        }
                        {item.name}
                    </div>
            ))
        }
    </div>;

    const handleSearch = (e) => {
        const value = e.target.value;
        setInputValue(value); // 更新状态
    }

    const handleJump = (item) => {
        if (item.jumpUrl?.startsWith('http')) window.open(item.jumpUrl, '_blank')
        else if (item.jumpUrl?.startsWith('/')) navigate(item.jumpUrl)
    }

    const handleJump2 = (item) => {
        if (item.partner?.startsWith('http')) window.open(item.partner, '_blank')
        else if (item.partner?.startsWith('/')) navigate(item.partner)
    }


    return (
        <div className="ecosystem-container">
            <div className="ecosystem-operation">
                <Row gutter={[20, 20]}>
                    <Col className="gutter-row" xs={24} sm={24} md={24} lg={5} xl={5} xxl={5}>
                        <Popover trigger="click" content={categorieContent}>
                            <div className="flex operation-item">
                                <img src={iconCategorie}/>
                                <span>Categories</span>
                                {
                                    filterCategories.length > 0 ?
                                        (
                                            <div style={{marginLeft: '6px', color: 'rgb(234 95 43)'}}>
                                                ({filterCategories.length})
                                            </div>
                                        ) : null
                                }
                            </div>
                        </Popover>
                    </Col>

                    <Col className="gutter-row" xs={24} sm={24} md={24} lg={19} xl={19} xxl={19}>
                        <div className="ecosystem-operation-right">
                            <Input size="large" allowClear value={inputValue} onChange={(e) => handleSearch(e)}
                                   placeholder="Search by name..."
                                   prefix={<img style={{width: '24px', height: '24px'}} src={iconSearch}/>}/>
                        </div>
                    </Col>
                </Row>
            </div>

            <div className='ecosystem-list'>
                <Row gutter={[40, 40]}>
                    {
                        list.map((item, index) =>
                          <Col className="gutter-row" key={index} xs={24} sm={24} md={12} lg={8} xl={8} xxl={6}>
                              <div className="ecosystem-item-wrap">
                                  <div className="ecosystem-item">
                                      <div className={`ecosystem-item-head flex flex-just`}>
                                          <img src={item.icon} className="ecosystem-item-icon" />
                                          <div className={`flex`}>
                                              {
                                                  item?.jumpUrl ? (
                                                    <img onClick={() => handleJump(item)} src={iconNetwork}
                                                         className="ecosystem-item-network" />
                                                  ) : null
                                              }
                                              {
                                                  item?.partner ? (
                                                    <img onClick={() => handleJump2(item)} src={iconShare}
                                                         className="ecosystem-item-share" />
                                                  ) : null
                                              }
                                          </div>
                                      </div>
                                      <h3 className="ecosystem-item-title">{item.title}</h3>
                                      <p className="ecosystem-item-content">{item.content}</p>
                                      <div className="ecosystem-item-tag flex">
                                          {
                                              item.tagList.map((item2, index2) => (
                                                <div style={{
                                                    background: item2.themeColor,
                                                }} className="tags" key={index2}>{item2.name}</div>
                                              ))
                                          }
                                      </div>
                                  </div>
                              </div>
                          </Col>
                        )
                    }
                </Row>
                <div className={`pagination-wrap`}>
                    <Pagination
                      showSizeChanger={false}
                      current={currentPage}
                      pageSize={pageSize}
                      onChange={onPageChange}
                      defaultCurrent={1}
                      total={total}
                    />
                </div>
            </div>

        </div>
    );
}

export default Ecosystem;
